import ProjectPackage from '../../components/projectPackage/ProjectPackage.vue'
import NewCourseDetails from '../../components/newcourseDetails/CourseDetails.vue'
// 旧的组件  小课程模块
// import CourseDetails from '../../components/courseDetails/CourseDetails.vue'
import RecommendedCourse from '../../components/recommendedCourse/RecommendedCourse.vue'
import RecommendedCourseRotationChart from '../../components/recommendedCourseRotationChart/RecommendedCourseRotationChart.vue'
import List01 from '../../components/list01/List01.vue'
import List02 from '../../components/list02/List02.vue'
import List03 from '../../components/list03/List03.vue'
import List04 from '../../components/list04/List04.vue'
import project from '../../components/project/Project.vue'
// 客服信息模块
import ServiceInformation from '../ServiceInformation/ServiceInformation.vue'
// 之前的组件的样式  
import Banner from '../banner/banner.vue'

// 改变后的组件的样式 
// import Banner from '../../components/banner/banner.vue'

export default {
    data() {
        return {
            //标签
            labels: {
                id: '0'
            },
            //轮播图
            sliderImgs: [],
            //推荐课程
            recommendCourseImg: [],
            // 板块数组
            sections: [],
            //搜索项目包输入的文字
            searchPackageName: "",
            // 新闻列表
            // newsList: [
            //     '中央政府门户网站：知行中国-中小学班主任教师国家级远程培训班开班sssssssssssssss',
            //     '中国教育新闻网："知行中国—中小学班主任国家级远程培训"开班',
            //     '光明日报：10万班主任参加“知行中国”远程培训',
            //     '中国新闻网：中国将远程培训10万名小学一线班主任教师',
            //     '中国教育报：问题解决让远程研修更接地气',
            //     '【中国教育报】信息技术与教师培训深度融合'
            // ],
            // 通知列表
            // informList: [
            //     {
            //         id: 1,
            //         year: '2019',
            //         time: '12.18',
            //         title: '中央财政下达19.85亿元，用于乡村中小幼教师培训'
            //     },
            //     {
            //         id: 2,
            //         year: '2019',
            //         time: '12.18',
            //         title: '聚焦！4月18日-19日，第十届长三角基础教育课程与教学改革论坛即将召开'
            //     },
            //     {
            //         id: 3,
            //         year: '2019',
            //         time: '12.18',
            //         title: '全国中小学教师信息技术应用能力提升工程2.0启动'
            //     }
            // ],
            // 轮播图列表
            bannerList: [],
            // 是否显示某个地区下的项目包详情
            isShow: false,
            // 项目包数组
            list: [],
            // 新闻列表
            newsList: [],
            // 通知列表
            noticesList: [],
            // baseUrl: 'https://education-project.bayou-tech.cn/',
            baseUrl: this.baseUrl,
        }
    },
    methods: {
        //获取首页数据
        getdata() {
            //获取板块信息
            this.$getStoreId().then(id => {
                this.$post('sections/search', { shop_id: id, offset: 0, length: 999 }).then(res => {
                    // // console.log(res)
                    this.sections = res.data.result.data;
                    //因为返回的对象里面的数组有产品数组，也有项目包数组，若
                    this.sections.map(item => {
                        //若产品数组为空则删除产品数组这个属性
                        if (item.section_products.length == 0) {
                            item.section_products = item.package_section;
                        }
                        //删除项目包数组这个属性
                        delete item.package_section;
                    })
                    // 请求得到的数据的操作  
                    // console.log(this.sections);
                })
            })
        },

        // 点击通知或指南进行跳转到详情页面
        handleClick(type, item) {
            this.$router.push({
                path: '/projectnews',
                query: {
                    id: item.id,
                    type: type
                }
            })
        },

        // 获取轮播图
        getBanner() {
            this.$post('banner/search', {
                shop_id: 8,
                offset: 0,
                length: 999
            }).then(res => {
                this.bannerList = res.data.result.data
            })
        },

        /**
         * 鼠标移入
         * @param {string} url url
         */
        onMouseOver(url) {
            this.isShow = true
            // 获取url下的所有项目包
            this.getPackageDetail(url)
        },

        // 鼠标移出
        onMouseLeave() {
            this.isShow = false
        },

        // 获取url下的所有项目包
        getPackageDetail(url) {
            this.$post('package/get_package_by_url', {
                url: url,
                offset: 0,
                length: 9999
            }).then(res => {
                let list = res.data.result.data
                this.handleArray(list)
            })
        },

        // 处理数组
        handleArray(arr) {
            // 先取出所有年度
            let yearsList = []
            let list = []
            arr.map(item => {

                item.package_attribute_value.map(item2 => {
                    if (item2.type === '年度') {
                        list.push({
                            year: Number.parseInt(item2.name)
                        })
                    } else if (item2.type === '地区') {
                        this.region = item2.name
                    }
                })
            })

            // 去掉重复的年度
            if (list.length === 1) {
                yearsList = list
            } else {
                var obj = {}
                yearsList = list.reduce((item, next) => {
                    obj[next.year] ? '' : obj[next.year] = true && item.push(next)
                    return item
                }, [])
            }

            // 向数组中添加年度相同的项目包
            for (let i = 0; i < yearsList.length; i++) {

                yearsList[i].list = []
                for (let j = 0; j < arr.length; j++) {

                    for (let k = 0; k < arr[j].package_attribute_value.length; k++) {
                        let data = arr[j].package_attribute_value[k]
                        if (data.type === '年度' && data.name == yearsList[i].year) {
                            yearsList[i].list.push(arr[j])
                        }
                    }
                }
            }
            this.list = yearsList
        },

        // 获取新闻
        getNews() {
            this.$post('product_news/get', {
                offset: 0,
                length: 5
            }).then(res => {
                this.newsList = res.data.result.data
            })
        },

        // 获取通知
        getNotices() {
            this.$post('product_notices/get', {
                offset: 0,
                length: 5
            }).then(res => {
                this.noticesList = res.data.result.data
            })
        },

        // 跳转到指定位置
        jumpLocaltion(name) {
            var a = document.createElement('a')
            a.setAttribute('href', '#' + name)
            a.click()
            // 滚动80px，才不会被tpheader挡住
            window.scrollBy(0, -80)
        },

        //跳转项目包主页
        toProjectHomePage(id) {

            // 从浏览器缓存中获取用户id，有就赋值
            let userid = sessionStorage.getItem('userid')

            if (!this.$isAbnormal(userid)) {
                // // console.log('有id')
                // 根据id获取域名
                this.$post('package/get_package', {
                    id: id
                }).then(res => {
                    let url = res.data.result.url

                    window.location = url + `/#/pojecthomepage?id=${userid}&package_id=${id}`

                    // window.location = url + '/#/?id=' + userid
                })
            } else {
                // // console.log('没id')
                // 根据id获取域名
                this.$post('package/get_package', {
                    id: id
                }).then(res => {
                    let url = res.data.result.url
                    // console.log(url)

                    window.location = url + `/#/pojecthomepage?package_id=${id}`
                    
                    // window.location = url + '/#/'
                })
            }

        },
    },
    components: {
        List01,
        List02,
        List03,
        List04,
        ProjectPackage,
        NewCourseDetails,
        // CourseDetails,
        RecommendedCourse,
        RecommendedCourseRotationChart,
        ServiceInformation,
        "banner-app": Banner,
        "Project": project
    },
    mounted: function () {
        // this.getLabel();
        this.getdata();
        // this.getSliderPhoto();
        document.title = this.$store.state.store.platform_name;

        // // console.log(this.$store.state.store.id)
    },
    created() {
        // 获取轮播图
        this.getBanner()
        // 获取新闻
        this.getNews()
        // 获取通知
        this.getNotices()
    },
}
